import React, { useState } from 'react';
import { PartnerRecommendation as PartnerRecommendationType } from '../../types/launchpad';
import PartnerRecommendation from './PartnerRecommendation';

interface PartnerRecommendationsProps {
  partners: PartnerRecommendationType[];
  userRegion?: string; // User's region (e.g., 'US', 'UK')
}

const PartnerRecommendations: React.FC<PartnerRecommendationsProps> = ({ 
  partners, 
  userRegion = 'US' 
}) => {
  const [expanded, setExpanded] = useState(false);
  
  // Filter partners by region
  const availablePartners = partners.filter(partner => 
    !partner.regions || 
    partner.regions.includes(userRegion) || 
    partner.regions.includes('Global')
  );
  
  if (!availablePartners.length) return null;
  
  // Show first partner by default, or all if expanded
  const displayPartners = expanded ? availablePartners : availablePartners.slice(0, 1);
  
  return (
    <div className="mt-4">
      <h3 className="text-md font-medium text-gray-700 mb-2 flex items-center">
        <svg className="w-5 h-5 mr-1 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
        Recommended Partners
      </h3>
      
      <div className="space-y-2">
        {displayPartners.map((partner, index) => (
          <PartnerRecommendation 
            key={`${partner.name}-${index}`} 
            partner={partner} 
            userRegion={userRegion} 
          />
        ))}
      </div>
      
      {availablePartners.length > 1 && (
        <button 
          onClick={() => setExpanded(!expanded)}
          className="text-blue-500 hover:text-blue-700 text-sm mt-2 flex items-center"
        >
          {expanded ? (
            <>
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
              </svg>
              Show less
            </>
          ) : (
            <>
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
              Show {availablePartners.length - 1} more partner{availablePartners.length > 2 ? 's' : ''}
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default PartnerRecommendations;
